export interface BaseMapTileLayerType {
  iconUrl?: string // 显示图标
  type: string // 类型
  label: string // 名称
  url: string // 瓦片地址
  id?: string | undefined
  minZoom?: number | undefined
  maxZoom?: number | undefined
  subdomains?: string | string[] | undefined
  errorTileUrl?: string | undefined
  checked?: boolean
}
export const baseMapTitleLayerConfig: BaseMapTileLayerType[] = [
  {
    iconUrl: 'https://lspt.xplusship.com/src/leaflet/img/map1.png',
    label: '海图',
    checked: true,
    url: `https://tile.xplusship.com/cmap/{x}/{y}/{z}/sea/2/1.jpg`,
    errorTileUrl: '',
    type: 'MT_SEA',
  },
  {
    iconUrl: 'https://lspt.xplusship.com/src/leaflet/img/map2.png',
    label: '地图',
    checked: false,
    type: 'MT_GOOGLE',
    url: `https://tile.xplusship.com/cmap/{x}/{y}/{z}/gdt/2/1.jpg`,
    // url: 'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    errorTileUrl: '',
  },
  {
    iconUrl: 'https://lspt.xplusship.com/src/leaflet/img/map3.png',
    label: '卫星图',
    checked: false,
    type: 'MT_SATELLITE',
    url: `https://tile.xplusship.com/cmap/{x}/{y}/{z}/gwx/2/1.jpg`,
    errorTileUrl: '',
  },
  {
    type: 'MT_SATELLITE_0',
    label: '海路图片',
    url: `https://tile.xplusship.com/cmap/{x}/{y}/{z}/gdt/2/1.jpg`,
    errorTileUrl: '',
  },
  {
    type: 'MT_SATELLITE_1',
    label: '卫星地图',
    url: `https://tile.xplusship.com/cmap/{x}/{y}/{z}/gwx/2/1.jpg`,
    errorTileUrl: '',
  },
  {
    type: 'MT_SATELLITE_2',
    label: '暗黑主题海图',
    url: `https://tile.xplusship.com/cmap/{x}/{y}/{z}/land/2/0.8/1.jpg`,
    errorTileUrl: '',
  },
]
